// Header.js

const Header = () => {
    return(
        <header>
          <div className="headerContainer">
            <div className="wrapper">
              <h1>Box Office Boffo</h1>
              <p>Summer is here and so are the summer blockbuster movies!</p>
            </div>
          </div> 
      </header>
    )
}

export default Header;